import React from 'react';
import { Route } from 'react-router-dom';
import { STATUS_OK, STATUS_NOT_FOUND, STATUS_SERVER_ERROR } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";

const Status = _ref => {
  let {
    children,
    status
  } = _ref;
  return /*#__PURE__*/_jsx(Route, {
    render: _ref2 => {
      let {
        staticContext
      } = _ref2;

      if (staticContext) {
        staticContext.status = status;
      }

      return children;
    },
    "data-id": "status_index_Status_Route"
  });
};

export default Status;